"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var styles = {
  gray: {
    fill: 'rgba(0,0,0,0.6)'
  },
  root: {
    height: 40,
    width: 98
  },
  white: {
    fill: 'rgb(255,255,255)'
  }
};
var _ref = /*#__PURE__*/_react["default"].createElement("title", null, "Proofpoint Logo");
var ProofpointLogo = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
    className = props.className,
    variant = props.variant;
  var colorClass;
  switch (variant) {
    case 'gray':
      {
        colorClass = classes.gray;
        break;
      }
    default:
      {
        colorClass = classes.white;
      }
  }
  return /*#__PURE__*/_react["default"].createElement("svg", {
    alt: "Proofpoint Logo",
    className: (0, _classnames["default"])(classes.root, className),
    ref: ref,
    viewBox: "0 0 519.18 96.99",
    xmlns: "http://www.w3.org/2000/svg"
  }, _ref, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M499.39,75.36V64.28h-3.83c-4.16,0-5.14-.62-5.14-3.52V30.33h9V20h-9V5H475V20h-7.66V30.33H475V60c0,11.49,2.74,15.63,15.54,15.63,1.64,0,4.6-.21,8.87-.31"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M410.91,74.94h15.54V42.34c0-7.25,4.71-11.59,11.93-11.59,6.67,0,9,3.52,9,11V74.94h15.54V37.47c0-12.63-6.35-18.94-19.15-18.94-7.34,0-13.24,2.69-17.62,8V20H410.91Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: colorClass,
    height: "13.35",
    width: "15.54",
    x: "385.84",
    y: "0.52"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: colorClass,
    height: "54.96",
    width: "15.54",
    x: "385.84",
    y: "19.98"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M336.71,47.41c0-11,5-17,13.68-17s13.57,6,13.57,17S359,64.49,350.38,64.49s-13.68-6.11-13.68-17.08m-15.76,0c0,18.32,11.16,29.39,29.44,29.39s29.44-11.07,29.44-29.39S368.66,18,350.38,18s-29.44,11.07-29.44,29.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M300.49,47.82c0,10.25-4.92,16.25-12.59,16.25-8.21,0-13-5.8-13-16.25,0-11.28,4.49-17.08,12.7-17.08s12.91,5.9,12.91,17.08M259.77,97h15.1V68.11c3.83,5.69,9.74,8.69,17.18,8.69,13.57,0,23.86-11.49,23.86-29.6,0-17.6-10-29.09-24.08-29.09-7.55,0-12.8,2.9-17.29,9.32V20H259.77Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M228.22,74.94h15.21V30.33h9.63V20h-9.74V16.15c0-3.52,1.42-4.14,5.69-4.14h4.05V.31C250.33.1,247.93,0,245.63,0c-11.93,0-17.4,4.56-17.4,14.91V20h-8.32V30.33h8.32Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M175.81,47.41c0-11,5-17,13.68-17s13.57,6,13.57,17-4.92,17.08-13.57,17.08-13.68-6.11-13.68-17.08m-15.76,0c0,18.32,11.16,29.39,29.44,29.39s29.44-11.07,29.44-29.39S207.76,18,189.48,18,160,29.09,160,47.41"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M113.38,47.41c0-11,5-17,13.68-17s13.57,6,13.57,17-4.92,17.08-13.57,17.08-13.68-6.11-13.68-17.08m-15.76,0c0,18.32,11.16,29.39,29.44,29.39S156.5,65.73,156.5,47.41,145.34,18,127.06,18,97.62,29.09,97.62,47.41"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M62.38,74.94H77.92V45.85c0-8.28,4.38-12.42,12.8-12.42h5.14V18.53a17.07,17.07,0,0,0-2.3-.1c-7.44,0-12.7,3.41-16.75,11V20H62.38Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M40.71,47.82c0,10.25-4.92,16.25-12.59,16.25-8.21,0-13-5.8-13-16.25,0-11.28,4.49-17.08,12.7-17.08s12.91,5.9,12.91,17.08M0,97H15.1V68.11c3.83,5.69,9.74,8.69,17.18,8.69,13.57,0,23.86-11.49,23.86-29.6,0-17.6-10-29.09-24.08-29.09-7.55,0-12.8,2.9-17.29,9.32V20H0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: colorClass,
    d: "M519.18,70.4a6.07,6.07,0,1,1-6-5.9A5.93,5.93,0,0,1,519.18,70.4Zm-10.62,0a4.57,4.57,0,0,0,4.61,4.72,4.52,4.52,0,0,0,4.5-4.68,4.56,4.56,0,1,0-9.11,0Zm3.64,3.1h-1.37V67.6a11.93,11.93,0,0,1,2.27-.18,3.68,3.68,0,0,1,2.05.43,1.64,1.64,0,0,1,.58,1.3,1.51,1.51,0,0,1-1.22,1.37v.07A1.74,1.74,0,0,1,515.58,72,4.52,4.52,0,0,0,516,73.5h-1.48a5,5,0,0,1-.47-1.44c-.11-.65-.47-.94-1.22-.94h-.65Zm0-3.35h.65c.76,0,1.37-.25,1.37-.86s-.4-.9-1.26-.9a3.26,3.26,0,0,0-.76.07Z"
  }))));
});
ProofpointLogo.defaultProps = {
  variant: 'white'
};
ProofpointLogo.displayName = 'ProofpointLogo';
ProofpointLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['gray', 'white'])
} : {};
var _default = (0, _styles.withStyles)(styles)(ProofpointLogo);
exports["default"] = _default;